import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css';
import { LoadingIcon } from '_components';
import { PatientCareCenterAlSelections } from './Selections';
import { PatientCareCenterAlBody } from './Body';


class PatientCareCenterAl extends React.Component {

    render() {
        if (this.props.loading) {
            return (
                <div className={styles.loading_div}>
                    <br />
                    <label>Loading...</label>
                    <br /><br />
                    <LoadingIcon size='large' />
                </div>
            );
        } else {
            return (
                <div>
                    <PatientCareCenterAlSelections epno={this.props.epno} />
                    <PatientCareCenterAlBody epno={this.props.epno} mcWrapper={this.props.mcWrapper} />
                </div>
            );
        }
    }

}

function mapStateToProps(state, ownprops) {
    let loading = state.ui.al[ownprops.epno] ? state.ui.al[ownprops.epno].loading : true;

    return {
        loading
    };
}

const connectedPatientCareCenterAl = connect(mapStateToProps)(PatientCareCenterAl);
export { connectedPatientCareCenterAl as PatientCareCenterAl };

